<div mat-dialog-title>Edit Profile</div>

<div mat-dialog-content>
  <form [formGroup]="formGroup">
    <div class="row">
      <mat-form-field>
        <mat-label>First Name</mat-label>
        <input matInput formControlName="fname" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lname" />
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" />
    </mat-form-field>
    <p>Email used for login can't be changed</p>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button matButton mat-dialog-close>Cancel</button>
  <app-button type="filled" [loading]="loading" (onClick)="save()"
    >Save</app-button
  >
</div>
